import Skeleton from "@/v2-ui/skeleton"
import cn from "@/v2-ui/utils/utils.cn"
import StatusStickyNav from "@/v2-status-client/status/nav/StatusStickyNav"

// Sticky platform-filter row placeholder. Renders inside the same
// `StatusStickyNav` wrapper as the live nav so the divider /
// blurred background already match without us reimplementing the
// sticky chrome. We seed five pill-shaped placeholders -- one
// "All platforms" + four platforms -- because that's the live
// shape today. The skeleton is non-interactive (no buttons,
// `aria-hidden`) so screen-readers don't announce phantom items.
function StatusPlatformNavSkeleton() {
  return (
    <StatusStickyNav>
      <div
        aria-hidden
        className={cn(
          "m-0 flex list-none gap-1.5 overflow-x-auto py-2 [scrollbar-width:none]",
          "[&::-webkit-scrollbar]:hidden",
        )}
      >
        {PILL_WIDTHS.map((w, i) => (
          <Skeleton key={i} className={cn("h-8 shrink-0 rounded-full", w)} />
        ))}
      </div>
    </StatusStickyNav>
  )
}

// Hand-picked pill widths so the skeleton looks like a real row
// of platforms with varying name lengths instead of identical
// matchsticks. Matches the live shape (~ "All platforms 4",
// "Placepoint 145", "Placepoint v1 8", "Propcloud 12",
// "Newsecmaps 19").
const PILL_WIDTHS = ["w-32", "w-28", "w-32", "w-28", "w-32"] as const

export default StatusPlatformNavSkeleton
